import { render, staticRenderFns } from "./DialogVisualizarComprovante.vue?vue&type=template&id=28e4d100&"
import script from "./DialogVisualizarComprovante.vue?vue&type=script&lang=js&"
export * from "./DialogVisualizarComprovante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports